// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","links":"footer_links__sRCmB","link":"footer_link__DsQ78","link-button":"footer_link-button__9RCIt"};